module.exports = __webpack_public_path__ + "img/4.0d74e333.png";